import { ArrowRightIcon, SparkleIcon } from '@phosphor-icons/react';
import { PillButton } from '@/components/kit';
import { clientSuggestions } from '@/features/assistant/suggestions';
import { useStudio } from '@/features/studio/studio-data';

/**
 * The assistant's entry on the home page: an accent-tinted panel that stands out from
 * the plain sections, two one-tap questions (sent as soon as the chat opens) and a
 * button that opens the chat empty.
 */
export function AssistantPromo({ onOpen }: { onOpen: (question?: string) => void }) {
  const studio = useStudio();
  return (
    <section className="ui-ai" aria-labelledby="ai-promo-title">
      <span className="ui-ai__head">
        <span className="ui-ai__icon" aria-hidden="true">
          <SparkleIcon size={22} weight="fill" />
        </span>
        <h2 className="ui-h2" id="ai-promo-title">
          Запись с ИИ
        </h2>
      </span>
      <p className="ui-ai__text">
        Опишите, что нужно машине, — помощник подберёт услугу, назовёт цену и ближайшее свободное время.
      </p>
      <span className="ui-ai__chips">
        {clientSuggestions(studio.services)
          .slice(0, 2)
          .map((question) => (
            <button key={question} type="button" className="ui-ai__chip" onClick={() => onOpen(question)}>
              {question}
            </button>
          ))}
      </span>
      <PillButton size="lg" block endIcon={ArrowRightIcon} className="ui-ai__cta" onClick={() => onOpen()}>
        Спросить помощника
      </PillButton>
    </section>
  );
}
